/* eslint-disable global-require, no-underscore-dangle */
import { createStore, applyMiddleware } from 'redux';
import { compose } from 'ramda';
import createSagaMiddleware from 'redux-saga';
import { routerMiddleware } from 'connected-react-router';

import rootReducer from './reducers';
import SagaManager from './SagaManager';

const composeEnhancers =
  process.env.NODE_ENV === 'production'
    ? compose
    : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

if (process.env.NODE_ENV === 'production') {
  // eslint-disable-next-line
  console.warn(`VERSION: ${process.env.REACT_APP_VERSION}`);
}

export default (persistedState, history) => {
  const sagaMiddleware = createSagaMiddleware({});
  const middlewares = [sagaMiddleware, routerMiddleware(history)];

  const enhancer = composeEnhancers(applyMiddleware(...middlewares));
  const store = createStore(rootReducer, persistedState, enhancer);

  SagaManager.startSagas(sagaMiddleware);

  if (module.hot) {
    module.hot.accept('./reducers', () => store.replaceReducer(require('./reducers').default));
    module.hot.accept('./SagaManager', () => {
      SagaManager.cancelSagas(store);
      require('./SagaManager').default.startSagas(sagaMiddleware);
    });
  }

  return store;
};
